import { styled } from '@linaria/react'

export const Subtitle = styled.h6`
  margin-bottom: 10px;

  @media screen and (max-width: 767.98px) {
    margin-bottom: 20px;
  }
`

export const Title = styled.h2`
  position: relative;
  margin: 0;

  span {
    position: relative;
    z-index: 2;
  }

  .dhsv-svg {
    position: absolute;
    top: 0;
    left: calc(50% - 20px);
    max-width: 430px;
    width: 100%;
    transform: translateX(calc(-50% - 20px));
    z-index: 1;
  }

  @media screen and (max-width: 767.98px) {
    .dhsv-svg {
      left: auto;
      right: 20px;
      max-width: 240px;
      transform: none;
    }
  }
`

export const Image = styled.div`
  position: relative;
  margin-top: 100px;
  text-align: center;

  img {
    position: relative;
    z-index: 2;
    margin: auto;
  }

  .dhsv-svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  @media screen and (max-width: 767.98px) {
    margin-top: 30px;
  }
`

export const ChildrenContent = styled.div`
  margin-top: 60px;

  .dhsv-button {
    margin-top: 60px;
  }

  @media screen and (max-width: 767.98px) {
    margin-top: 45px;

    > div:nth-child(2) {
      text-align: center;
    }

    .dhsv-button {
      margin-top: 50px;
    }
  }
`
